<div class="mode-wrapper">
    <cc-option-toggle
        [labels]="{ trueLabel: 'USE DATE RANGE', falseLabel: 'ACTIVE DATE' }"
        [(value)]="useFullDateRange"
        (valueChange)="modeChange.emit(useFullDateRange ? 'date-range' : 'active-date')"
    >
    </cc-option-toggle>
</div>

<cc-date-picker
    [disabled]="useFullDateRange"
    [fuzzies]="fuzzyDates"
    [(value)]="activeDate"
    [minDate]="minDate"
    [maxDate]="maxDate"
    (valueChange)="onActiveDateChanged()"
>
</cc-date-picker>
